/**
 * Lazy load for Featured Collection Tabs.
 * Fetches only product cards via Section Rendering API, injects into existing ul.
 */
(function () {
    const PRODUCTS_SELECTOR = ".featured-collection-tab-products";

    function loadTabContent(panel) {
        const fetchUrl = panel.dataset.fetchUrl;
        if (!fetchUrl || panel.dataset.needsLoad !== "true") return;

        const productsUl = panel.querySelector("[data-products-container]");
        if (!productsUl) return;

        panel.setAttribute("aria-busy", "true");

        fetch(fetchUrl)
            .then((response) => response.text())
            .then((html) => {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = html;
                const productsContainer = tempDiv.querySelector(PRODUCTS_SELECTOR);

                if (productsContainer && productsContainer.innerHTML.trim()) {
                    productsUl.innerHTML = productsContainer.innerHTML;
                } else {
                    productsUl.innerHTML =
                        "<li><p class=\"text-center text-theme-subdued py-8\">No products in this collection.</p></li>";
                }
                panel.removeAttribute("data-needs-load");
                panel.removeAttribute("data-fetch-url");

                // Re-init carousel and OverlayScrollbars for dynamically loaded content
                requestAnimationFrame(() => {
                    const carousels = panel.querySelectorAll("carousel-slider");
                    carousels.forEach((carousel) => {
                        if (typeof carousel.refresh === "function") {
                            carousel.refresh();
                        }
                    });
                });
            })
            .catch((error) => {
                console.error("Featured collection tab load error:", error);
                productsUl.innerHTML =
                    "<li><p class=\"text-center text-theme-subdued py-8\">Content could not be loaded. Please try again.</p></li>";
            })
            .finally(() => {
                panel.setAttribute("aria-busy", "false");
            });
    }

    function initLazyLoad(wrapper) {
        const tabButtons = wrapper.querySelectorAll("[tab-button]");
        if (!tabButtons.length) return;

        tabButtons.forEach((btn) => {
            btn.addEventListener("click", () => {
                const panelId = btn.getAttribute("panel-for");
                if (!panelId) return;

                const panel = wrapper.querySelector(`#${CSS.escape(panelId)}`);
                if (!panel) return;

                // Use setTimeout to run after tab-content-wrapper switches the panel
                setTimeout(() => loadTabContent(panel), 0);
            });
        });
    }

    function init() {
        const wrappers = document.querySelectorAll(
            "tab-content-wrapper[data-lazy-load=\"featured-collection-tabs\"]"
        );
        wrappers.forEach(initLazyLoad);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
